<template>
  <div class="d-flex text-muted align-items-center mr-3">
    <i class="mr-1 mr-md-0 mr-lg-1 pr-1  gf-icon gf-icon-comment" />
    <span>{{ getCounter }}</span>
  </div>
</template>

<script>
import Issue from '@shared/services/issue.service';

export default {
  computed: {
    getCounter() {
      return this.$store.getters.getDiscussionsCounter;
    }
  },
  mounted() {
    this.getDiscussionCounterValue();
  },
  methods: {
    getDiscussionCounterValue() {
      Issue.getDiscussionCounterValue(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.issueId
      );
    }
  }
};
</script>
